import { css } from '@emotion/css'
import { spacing, borderRadius, colors, fontWeight, fontSize, mediaQueryHelper, breakpoint } from '@offerzen/pinata'

const styles = {
  cardHeader: css({
    display: 'grid',
    alignItems: 'center',
    columnGap: spacing.default,
    gridTemplateRows: 'auto',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "applicationChip applicationChip"
    "companyLogo ."
    "companyLogo jobTitle"
    "companyLogo companyName"
    "companyLogo ."
  `,

    a: {
      gridArea: 'jobTitle',

      '&:hover': {
        h2: {
          textDecoration: 'underline',
        },
      },

      h2: {
        fontWeight: fontWeight.bold,
        fontSize: fontSize.medium,
      },
    },

    p: {
      gridArea: 'companyName',
      color: colors.scorpion,
      margin: 0,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      columnGap: spacing.medium,
      rowGap: spacing.extraSmall,
      gridTemplateColumns: 'auto auto 1fr',
      gridTemplateAreas: `
      "companyLogo . ."
      "companyLogo jobTitle applicationChip"
      "companyLogo companyName ."
      "companyLogo . ."
    `,
    },
  }),

  companyImage: css({
    gridArea: 'companyLogo',
    borderRadius: borderRadius.medium,
    boxSizing: 'border-box',
    padding: spacing.small,
    border: `1px solid ${colors.mystic}`,
    width: 65,
    height: 65,

    img: {
      objectFit: 'contain',
    },
  }),

  applicationStatusChip: css({
    gridArea: 'applicationChip',
    marginBottom: spacing.default,
    justifySelf: 'flex-start',

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginBottom: 0,
    },
  }),
}

export default styles
